import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { read } from '../lib/store.js';

export function renderSchedule() {
  const root = $('#schedule-list');
  if (!root) return;
  const matches = read('matches');
  if (!matches || matches.length === 0) {
    renderEmpty(root);
    return;
  }
  matches.forEach(m => {
    const d = document.createElement('div');
    d.className = 'match';
    d.innerHTML = `
      <div class="date">${esc(m.day)}<small>${esc(m.date)} · '26</small></div>
      <div class="team us">
        <div class="badge">GG</div>
        <div><div class="nm">${esc(m.us)}</div><div class="sub">// HOME · DAD-MODE</div></div>
      </div>
      <div class="team">
        <span class="vs">VS</span>
        <div class="badge">??</div>
        <div><div class="nm">${esc(m.them)}</div><div class="sub">// SINGLE · CHILDLESS · WELL-RESTED</div></div>
      </div>
      <div class="when">${esc(m.when)}<small>${esc(m.note)}</small></div>
      <div class="status"><span class="pill-x ${esc(m.cls)}">${esc(m.status)}</span></div>
    `;
    root.appendChild(d);
  });
}

function renderEmpty(root) {
  const slot = document.createElement('div');
  slot.className = 'empty-slot';
  slot.innerHTML = `
    <div class="slip">
      <div class="slip-face">
        <header class="slip-head">
          <span class="form-no">FORM 04-B · MATCH SLIP</span>
          <span class="copy-no">// COPY 1 OF 3 · PINK</span>
        </header>

        <div class="slip-stamp" aria-hidden="true">VOID</div>

        <div class="slip-body">
          <div class="lead">
            <div class="kicker">// SCHEDULE STATUS</div>
            <h3>No matches<br /><span class="blaze">on the books.</span></h3>
            <p class="sub">
              Coach is mid-bedtime. Captain's wife said "<em>maybe next weekend</em>"
              — which is a <span class="lime">tentative no</span>. Slips return once the kids are down.
            </p>
          </div>

          <dl class="slip-fields">
            <div><dt>DATE</dt><dd class="dashed">__ / __ / '26</dd></div>
            <div><dt>OPPONENT</dt><dd class="dashed">T B D</dd></div>
            <div><dt>TIME</dt><dd class="dashed">POST-BEDTIME (PROB.)</dd></div>
            <div><dt>STATUS</dt><dd><span class="pill-x nap">NAP DEPENDENT</span></dd></div>
            <div><dt>BLOCKER</dt><dd class="dashed">WIFE APPROVAL PENDING</dd></div>
            <div><dt>SIGN-OFF</dt><dd class="dashed">_________________</dd></div>
          </dl>
        </div>

        <footer class="slip-foot">
          <a href="#recruit" class="cta-slot">Poke the captain <span aria-hidden="true">→</span></a>
          <span class="mono small">// FILE LOST IN THE DIAPER BAG · 04.18.2026</span>
        </footer>
      </div>
    </div>
  `;
  root.appendChild(slot);
}
